import { apiRequest } from './auth';

const dashboardHistoryAPI = {
  // Pobierz całą historię Dashboard dla projektu
  getByProject: async (project) => {
    return await apiRequest(`/dashboard/history/${project}`);
  },

  // Dodaj wpis do historii Dashboard
  create: async (historyEntry) => {
    return await apiRequest('/dashboard/history', {
      method: 'POST',
      body: JSON.stringify(historyEntry),
    });
  },

  // Zaktualizuj wpis w historii Dashboard
  update: async (id, data) => {
    return await apiRequest(`/dashboard/history/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  // Znajdź ostatni wpis dla karty z określonym statusem
  findLastByCardAndStatus: async (project, cardNumber, statusTo) => {
    return await apiRequest(`/dashboard/history/${project}/${cardNumber}/${statusTo}`);
  },

  // Usuń wpis z historii Dashboard
  delete: async (id) => {
    return await apiRequest(`/dashboard/history/${id}`, {
      method: 'DELETE',
    });
  },

  // Usuń wiele wpisów z historii Dashboard
  deleteMany: async (ids) => {
    return await apiRequest('/dashboard/history/batch', {
      method: 'DELETE',
      body: JSON.stringify({ ids }),
    });
  },

  // Oznacz wpis jako wysłany
  markAsSent: async (id, sentBy, sentByLastName, sentAt) => {
    return await apiRequest(`/dashboard/history/${id}/send`, {
      method: 'POST',
      body: JSON.stringify({ sentBy, sentByLastName, sentAt }),
    });
  },
};

export default dashboardHistoryAPI;
